<template>
  <v-container
    grid-list-md
    align-center
    fill-height
    align-content-center
  >
    <v-layout
      column
      fill-height
    >
      <v-layout
        row
        fill-height
        align-center
        justify-center
      >
        <v-icon
          large
          color="secondary"
        >
          info_outline
        </v-icon>
        <v-flex md7>
          <div class="subheading">
            {{ $t('appointment.summary') }}
          </div>
        </v-flex>
      </v-layout>
      <StepperButtons
        :change-step="changeStep"
        :active="active"
        :number-of-steps="numberOfSteps"
        :form="{}"
      />
    </v-layout>
  </v-container>
</template>

<script>
import StepperButtons from '../StepperButtons'

export default {
  name: 'SummaryStep',
  components: {
    StepperButtons,
  },
  props: {
    active: {
      type: Number,
      required: true,
    },
    changeStep: {
      type: Function,
      required: true,
    },
    numberOfSteps: {
      type: Number,
      required: true,
    },
  },
}
</script>

<style scoped>

</style>
